import request from '@/config/axios'

export interface AreaAgentWithdrawVO {
  id?: number
  userId?: number
  userNickname?: string
  price?: number
  feePrice?: number
  type?: number
  userName?: string
  userAccount?: string
  bankName?: string
  bankAddress?: string
  qrCodeUrl?: string
  status?: number
  auditReason?: string
  auditTime?: string
  remark?: string
  payTransferId?: number
  transferChannelCode?: string
  transferErrorMsg?: string
  transferTime?: string
  createTime?: string
}

export const getAreaAgentWithdrawPage = async (params: any) => {
  return await request.get({ url: '/trade/area-agent/withdraw/page', params })
}

export const getAreaAgentWithdraw = async (id: number) => {
  return await request.get({ url: '/trade/area-agent/withdraw/get', params: { id } })
}

export const approveAreaAgentWithdraw = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/withdraw/approve', params: { id } })
}

export const rejectAreaAgentWithdraw = async (data: { id: number; auditReason?: string }) => {
  return await request.put({ url: '/trade/area-agent/withdraw/reject', data })
}

export const reTransferAreaAgentWithdraw = async (id: number) => {
  return await request.put({ url: '/trade/area-agent/withdraw/re-transfer', params: { id } })
}
